export interface FdpInvoiceListDataArgs {
  pageIndex: number;
  pageSize: number;
}

export enum FDP_INVOICE_COLUMN_NAME {
  // sl.no., pdf file download button, invoice start date, invoice end date, invoice generation date
  SL_NO = "slNo",
  INVOICE_ID = "fdpInvoiceId",
  ASSOCIATED_STORES = "stores",
  ASSOCIATED_CLIENTS = "clients",
  INVOICE_GENERATION_DATE = "invoiceDate",
  INVOICE_STATUS = "invoiceStatus",
  AUTO_GENERATED = "isAutoGenerated",
  CREATED_ON = "createdOn",
  UPDATED_ON = "updatedOn",
  RECEIPT_UPLOADED_ON = "receiptUploadedOn",
  RECEIPT_UPDATED_BY = "receiptUpdatedBy",
  RECEIPT_FILE = "receiptFile",
  NET_PAYMENT = "totalNetPayment"
}

export enum FDP_INVOICE_LABEL_NAME {
  SL_NO = "Sl. No.",
  INVOICE_ID = "Invoice Number",
  ASSOCIATED_STORES = "Associated Stores",
  ASSOCIATED_CLIENTS = "Associated Clients",
  INVOICE_GENERATION_DATE = "Invoice Generation Date",
  INVOICE_STATUS = "Invoice Status",
  AUTO_GENERATED = "Auto Generated",
  CREATED_ON = "Invoice Created On",
  UPDATED_ON = "Updated On",
  RECEIPT_UPLOADED_ON = "Receipt Uploaded On",
  RECEIPT_UPDATED_BY = "Receipt Updated By",
  RECEIPT_FILE = "invoice",
  NET_PAYMENT = "Net Payment ($)"
}

//TODO: need to add status for FDP Invoice
export const FDP_INVOICE_STATUS = {
  GENERATED: "generated",
  FDP_ACCEPTED: "fdp_accepted",
  PROTEST: "protest",
  FIN_APPROVED: "fin_approved",
  FIN_FLAGGED: "fin_flagged",
  OPS_APPROVED: "ops_approved",
  FIN_ACCEPTED: "fin_accepted",
  DRAFT: "draft",
  OPS_EDITED: "ops_edited",
  PAID: "paid",
  NEW_INVOICE: "fin_accepted",
};
